import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessageIssueTypeNameTooShort: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.too-short-error-name',
		defaultMessage: 'Add a name.',
		description: 'Error displayed when issue type name is too short.',
	},
	errorMessageIssueTypeNameAlreadyExists: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.already-exists-error-name',
		defaultMessage: 'Already exists. Try a different name.',
		description: 'Error displayed when name entered is already assigned to another issue type.',
	},
	errorMessageIssueTypeNameTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.too-long-error-name',
		defaultMessage: "Name can't exceed {maximumNameLength} characters",
		description: 'Error displayed when issue type name is too long.',
	},
	errorMessageIssueTypeHelpTextTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.help-text-inline-input.too-long-error-name',
		defaultMessage: "Help text can't exceed {maximumHelpTextLength} characters",
		description: 'Error message when help text is too long.',
	},
	errorMessageDescriptionTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.description-inline-input.too-long-error-name',
		defaultMessage: "Description can't exceed {maximumDescriptionLength} characters",
		description: 'Error message when description is too long.',
	},
});
